var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { getHeaders } from "../utils/apiUtils";
import { API_PATHS, legalDepositsTitlesId, legalDepositsTitlesSearchId, legalDepositsTitlesIdPairPublisher, legalDepositsTitlesIdReject, legalDepositsTitlesIdStartInvestigation, legalDepositsTitlesIdResolveInvestigation, legalDepositsTitlesIdInvestigationNotes, legalDepositsTitleProvisionalId, legalDepositsTitlesIdMergeWith, legalDepositsTitlesIdMergeCandidates, legalDepositsTitlesIdForce, } from "../types/apiPaths";
export var fetchTitleNameSuggestions = function (kyInstance_1, search_1, _a) { return __awaiter(void 0, [kyInstance_1, search_1, _a], void 0, function (kyInstance, search, _b) {
    var searchParams, response, data, error_1;
    var _c;
    var scope = _b.scope, type = _b.type, libraryStatus = _b.libraryStatus;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _d.trys.push([0, 3, , 4]);
                searchParams = new URLSearchParams();
                searchParams.append("search", search);
                searchParams.append("scope", scope);
                if (type)
                    searchParams.append("type", type);
                if (libraryStatus)
                    searchParams.append("libraryStatus", libraryStatus);
                return [4 /*yield*/, kyInstance.get(API_PATHS.LEGAL_DEPOSITS_TITLES_SUGGEST, { searchParams: searchParams, headers: getHeaders() })];
            case 1:
                response = _d.sent();
                if (!response.ok) {
                    throw new Error("Fetch error: ".concat(response.statusText));
                }
                return [4 /*yield*/, response.json()];
            case 2:
                data = _d.sent();
                return [2 /*return*/, (_c = data.items) !== null && _c !== void 0 ? _c : []];
            case 3:
                error_1 = _d.sent();
                console.error("Error fetching title name suggestions:", error_1);
                throw error_1;
            case 4: return [2 /*return*/];
        }
    });
}); };
export var fetchTitlesByIsbn = function (kyInstance_1, withIsbn_1) {
    var args_1 = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        args_1[_i - 2] = arguments[_i];
    }
    return __awaiter(void 0, __spreadArray([kyInstance_1, withIsbn_1], args_1, true), void 0, function (kyInstance, withIsbn, params) {
        var title, isbn, publisherId, minDaysSinceUrgence, statuses, enforcementTypes, provisional, extraCopies, extraCopyReason, sortBy, sortDir, _a, offset, _b, limit, searchParams_1, response, error_2;
        if (params === void 0) { params = {}; }
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 3, , 4]);
                    title = params.title, isbn = params.isbn, publisherId = params.publisherId, minDaysSinceUrgence = params.minDaysSinceUrgence, statuses = params.statuses, enforcementTypes = params.enforcementTypes, provisional = params.provisional, extraCopies = params.extraCopies, extraCopyReason = params.extraCopyReason, sortBy = params.sortBy, sortDir = params.sortDir, _a = params.offset, offset = _a === void 0 ? 0 : _a, _b = params.limit, limit = _b === void 0 ? 20 : _b;
                    searchParams_1 = new URLSearchParams();
                    if (title)
                        searchParams_1.append("title", title);
                    if (isbn)
                        searchParams_1.append("isbn", isbn);
                    if (publisherId)
                        searchParams_1.append("publisherId", publisherId);
                    if (minDaysSinceUrgence)
                        searchParams_1.append("minDaysSinceUrgence", minDaysSinceUrgence);
                    if (statuses)
                        statuses.forEach(function (status) { return searchParams_1.append("status", status); });
                    if (enforcementTypes)
                        enforcementTypes.forEach(function (enforcementType) {
                            return searchParams_1.append("enforcementType", enforcementType);
                        });
                    if (params.partiallyReceived)
                        searchParams_1.append("partiallyReceived", "true");
                    if (provisional)
                        searchParams_1.append("provisional", "true");
                    if (extraCopies)
                        searchParams_1.append("extraCopies", "true");
                    if (extraCopyReason)
                        searchParams_1.append("extraCopyReason", extraCopyReason);
                    if (params.agendaState)
                        searchParams_1.append("agendaState", params.agendaState);
                    if (params.allLibraries)
                        searchParams_1.append("allLibraries", "true");
                    if (params.exactCount)
                        searchParams_1.append("exactCount", "true");
                    if (params.countOnly)
                        searchParams_1.append("countOnly", "true");
                    if (sortBy)
                        searchParams_1.append("sortBy", sortBy);
                    if (sortDir)
                        searchParams_1.append("sortDir", sortDir);
                    searchParams_1.append("offset", offset.toString());
                    searchParams_1.append("limit", limit.toString());
                    return [4 /*yield*/, kyInstance.get(withIsbn
                            ? API_PATHS.LEGAL_DEPOSITS_TITLES_WITH_ISBN
                            : API_PATHS.LEGAL_DEPOSITS_TITLES_WITHOUT_ISBN, { searchParams: searchParams_1, headers: getHeaders() })];
                case 1:
                    response = _c.sent();
                    if (!response.ok) {
                        throw new Error("Fetch error: ".concat(response.statusText));
                    }
                    return [4 /*yield*/, response.json()];
                case 2: return [2 /*return*/, _c.sent()];
                case 3:
                    error_2 = _c.sent();
                    console.error("Error fetching titles ".concat(withIsbn ? "with" : "without", " ISBN:"), error_2);
                    throw error_2;
                case 4: return [2 /*return*/];
            }
        });
    });
};
export var fetchRequestableTitles = function (kyInstance_1) {
    var args_1 = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args_1[_i - 1] = arguments[_i];
    }
    return __awaiter(void 0, __spreadArray([kyInstance_1], args_1, true), void 0, function (kyInstance, params) {
        var title, isbn, publisherId, sortBy, sortDir, _a, offset, _b, limit, searchParams, response, error_3;
        if (params === void 0) { params = {}; }
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 3, , 4]);
                    title = params.title, isbn = params.isbn, publisherId = params.publisherId, sortBy = params.sortBy, sortDir = params.sortDir, _a = params.offset, offset = _a === void 0 ? 0 : _a, _b = params.limit, limit = _b === void 0 ? 20 : _b;
                    searchParams = new URLSearchParams();
                    if (title)
                        searchParams.append("title", title);
                    if (isbn)
                        searchParams.append("isbn", isbn);
                    if (publisherId)
                        searchParams.append("publisherId", publisherId);
                    if (params.requestedOnly)
                        searchParams.append("requestedOnly", "true");
                    if (params.exactCount)
                        searchParams.append("exactCount", "true");
                    if (params.countOnly)
                        searchParams.append("countOnly", "true");
                    if (sortBy)
                        searchParams.append("sortBy", sortBy);
                    if (sortDir)
                        searchParams.append("sortDir", sortDir);
                    searchParams.append("offset", offset.toString());
                    searchParams.append("limit", limit.toString());
                    return [4 /*yield*/, kyInstance.get(API_PATHS.LEGAL_DEPOSITS_TITLES_REQUESTABLE, { searchParams: searchParams, headers: getHeaders() })];
                case 1:
                    response = _c.sent();
                    if (!response.ok) {
                        throw new Error("Fetch error: ".concat(response.statusText));
                    }
                    return [4 /*yield*/, response.json()];
                case 2: return [2 /*return*/, _c.sent()];
                case 3:
                    error_3 = _c.sent();
                    console.error("Error fetching requestable titles:", error_3);
                    throw error_3;
                case 4: return [2 /*return*/];
            }
        });
    });
};
export var fetchTitleById = function (kyInstance, id) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_4;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                return [4 /*yield*/, kyInstance.get(legalDepositsTitlesId(id), {
                        headers: getHeaders(),
                    })];
            case 1:
                response = _a.sent();
                if (!response.ok) {
                    throw new Error("Fetch error: ".concat(response.statusText));
                }
                return [4 /*yield*/, response.json()];
            case 2: return [2 /*return*/, _a.sent()];
            case 3:
                error_4 = _a.sent();
                console.error("Error fetching title by ID:", error_4);
                throw error_4;
            case 4: return [2 /*return*/];
        }
    });
}); };
export var fetchTitleSearchById = function (kyInstance, id, issueId) { return __awaiter(void 0, void 0, void 0, function () {
    var searchParams, response, error_5;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                searchParams = new URLSearchParams();
                if (issueId)
                    searchParams.append("issueId", issueId);
                return [4 /*yield*/, kyInstance.get(legalDepositsTitlesSearchId(id), {
                        searchParams: searchParams,
                        headers: getHeaders(),
                    })];
            case 1:
                response = _a.sent();
                if (!response.ok) {
                    throw new Error("Fetch error: ".concat(response.statusText));
                }
                return [4 /*yield*/, response.json()];
            case 2: return [2 /*return*/, _a.sent()];
            case 3:
                error_5 = _a.sent();
                console.error("Error fetching title search projection by ID:", error_5);
                throw error_5;
            case 4: return [2 /*return*/];
        }
    });
}); };
export var fetchTitlesForVerification = function (kyInstance_1) {
    var args_1 = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args_1[_i - 1] = arguments[_i];
    }
    return __awaiter(void 0, __spreadArray([kyInstance_1], args_1, true), void 0, function (kyInstance, params) {
        var search, investigationStatus, publisher, sortBy, sortDir, _a, offset, _b, limit, searchParams, response, error_6;
        if (params === void 0) { params = {}; }
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 3, , 4]);
                    search = params.search, investigationStatus = params.investigationStatus, publisher = params.publisher, sortBy = params.sortBy, sortDir = params.sortDir, _a = params.offset, offset = _a === void 0 ? 0 : _a, _b = params.limit, limit = _b === void 0 ? 100 : _b;
                    searchParams = new URLSearchParams();
                    if (search)
                        searchParams.append("search", search);
                    if (investigationStatus)
                        searchParams.append("investigationStatus", investigationStatus);
                    if (publisher)
                        searchParams.append("publisher", publisher);
                    if (params.provisional)
                        searchParams.append("provisional", "true");
                    if (params.exactCount)
                        searchParams.append("exactCount", "true");
                    if (params.countOnly)
                        searchParams.append("countOnly", "true");
                    if (sortBy)
                        searchParams.append("sortBy", sortBy);
                    if (sortDir)
                        searchParams.append("sortDir", sortDir);
                    searchParams.append("offset", offset.toString());
                    searchParams.append("limit", limit.toString());
                    return [4 /*yield*/, kyInstance.get(API_PATHS.LEGAL_DEPOSITS_TITLES_PENDING_VERIFICATION, { searchParams: searchParams, headers: getHeaders() })];
                case 1:
                    response = _c.sent();
                    if (!response.ok) {
                        throw new Error("Fetch error: ".concat(response.statusText));
                    }
                    return [4 /*yield*/, response.json()];
                case 2: return [2 /*return*/, _c.sent()];
                case 3:
                    error_6 = _c.sent();
                    console.error("Error fetching titles for verification:", error_6);
                    throw error_6;
                case 4: return [2 /*return*/];
            }
        });
    });
};
export var pairPublisher = function (kyInstance_1, titleId_1, publisherId_1) {
    var args_1 = [];
    for (var _i = 3; _i < arguments.length; _i++) {
        args_1[_i - 3] = arguments[_i];
    }
    return __awaiter(void 0, __spreadArray([kyInstance_1, titleId_1, publisherId_1], args_1, true), void 0, function (kyInstance, titleId, publisherId, createMapping) {
        var response, error_7;
        if (createMapping === void 0) { createMapping = true; }
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    return [4 /*yield*/, kyInstance.post(legalDepositsTitlesIdPairPublisher(titleId), {
                            json: { publisherId: publisherId, createMapping: createMapping },
                            headers: getHeaders(),
                        })];
                case 1:
                    response = _a.sent();
                    if (!response.ok) {
                        throw new Error("Pair publisher error: ".concat(response.statusText));
                    }
                    return [4 /*yield*/, response.json()];
                case 2: return [2 /*return*/, _a.sent()];
                case 3:
                    error_7 = _a.sent();
                    console.error("Error pairing publisher:", error_7);
                    throw error_7;
                case 4: return [2 /*return*/];
            }
        });
    });
};
export var rejectTitle = function (kyInstance, titleId, reason) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_8;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, kyInstance.post(legalDepositsTitlesIdReject(titleId), {
                        json: { reason: reason },
                        headers: getHeaders(),
                    })];
            case 1:
                response = _a.sent();
                if (!response.ok) {
                    throw new Error("Reject title error: ".concat(response.statusText));
                }
                return [3 /*break*/, 3];
            case 2:
                error_8 = _a.sent();
                console.error("Error rejecting title:", error_8);
                throw error_8;
            case 3: return [2 /*return*/];
        }
    });
}); };
export var startInvestigation = function (kyInstance, titleId, note) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_9;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, kyInstance.patch(legalDepositsTitlesIdStartInvestigation(titleId), { json: { note: note }, headers: getHeaders() })];
            case 1:
                response = _a.sent();
                if (!response.ok) {
                    throw new Error("Start investigation error: ".concat(response.statusText));
                }
                return [3 /*break*/, 3];
            case 2:
                error_9 = _a.sent();
                console.error("Error starting investigation:", error_9);
                throw error_9;
            case 3: return [2 /*return*/];
        }
    });
}); };
export var resolveInvestigation = function (kyInstance, titleId, note) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_10;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, kyInstance.patch(legalDepositsTitlesIdResolveInvestigation(titleId), { json: { note: note || null }, headers: getHeaders() })];
            case 1:
                response = _a.sent();
                if (!response.ok) {
                    throw new Error("Resolve investigation error: ".concat(response.statusText));
                }
                return [3 /*break*/, 3];
            case 2:
                error_10 = _a.sent();
                console.error("Error resolving investigation:", error_10);
                throw error_10;
            case 3: return [2 /*return*/];
        }
    });
}); };
export var addInvestigationNote = function (kyInstance, titleId, text) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_11;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                return [4 /*yield*/, kyInstance.post(legalDepositsTitlesIdInvestigationNotes(titleId), { json: { text: text }, headers: getHeaders() })];
            case 1:
                response = _a.sent();
                if (!response.ok) {
                    throw new Error("Add note error: ".concat(response.statusText));
                }
                return [4 /*yield*/, response.json()];
            case 2: return [2 /*return*/, _a.sent()];
            case 3:
                error_11 = _a.sent();
                console.error("Error adding title note:", error_11);
                throw error_11;
            case 4: return [2 /*return*/];
        }
    });
}); };
export var fetchInvestigationNotes = function (kyInstance, titleId) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_12;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                return [4 /*yield*/, kyInstance.get(legalDepositsTitlesIdInvestigationNotes(titleId), {
                        headers: getHeaders(),
                    })];
            case 1:
                response = _a.sent();
                if (!response.ok) {
                    throw new Error("Fetch notes error: ".concat(response.statusText));
                }
                return [4 /*yield*/, response.json()];
            case 2: return [2 /*return*/, _a.sent()];
            case 3:
                error_12 = _a.sent();
                console.error("Error fetching title notes:", error_12);
                throw error_12;
            case 4: return [2 /*return*/];
        }
    });
}); };
export var verifyTitlesBulk = function (kyInstance, selection, publisherId) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_13;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                return [4 /*yield*/, kyInstance.post(API_PATHS.LEGAL_DEPOSITS_TITLES_VERIFY_BY_TITLES, { json: { selection: selection, publisherId: publisherId }, headers: getHeaders() })];
            case 1:
                response = _a.sent();
                if (!response.ok) {
                    throw new Error("Bulk verify titles error: ".concat(response.statusText));
                }
                return [4 /*yield*/, response.json()];
            case 2: return [2 /*return*/, _a.sent()];
            case 3:
                error_13 = _a.sent();
                console.error("Error bulk-verifying titles:", error_13);
                throw error_13;
            case 4: return [2 /*return*/];
        }
    });
}); };
export var createProvisionalTitle = function (kyInstance, body) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, kyInstance.post(API_PATHS.LEGAL_DEPOSITS_TITLES_PROVISIONAL, { json: body, headers: getHeaders() })];
            case 1:
                response = _a.sent();
                if (!response.ok) {
                    throw new Error("Create provisional title error: ".concat(response.statusText));
                }
                return [2 /*return*/, response.json()];
        }
    });
}); };
export var updateProvisionalTitle = function (kyInstance, id, body) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, kyInstance.patch(legalDepositsTitleProvisionalId(id), {
                    json: body,
                    headers: getHeaders(),
                })];
            case 1:
                response = _a.sent();
                if (!response.ok) {
                    throw new Error("Update provisional title error: ".concat(response.statusText));
                }
                return [2 /*return*/, response.json()];
        }
    });
}); };
export var mergeProvisionalTitle = function (kyInstance, provisionalId, realId) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, kyInstance.post(legalDepositsTitlesIdMergeWith(provisionalId, realId), { headers: getHeaders() })];
            case 1:
                response = _a.sent();
                if (!response.ok) {
                    throw new Error("Merge provisional title error: ".concat(response.statusText));
                }
                return [2 /*return*/, response.json()];
        }
    });
}); };
export var fetchProvisionalMergeCandidates = function (kyInstance_1, provisionalId_1, search_1, type_1) {
    var args_1 = [];
    for (var _i = 4; _i < arguments.length; _i++) {
        args_1[_i - 4] = arguments[_i];
    }
    return __awaiter(void 0, __spreadArray([kyInstance_1, provisionalId_1, search_1, type_1], args_1, true), void 0, function (kyInstance, provisionalId, search, type, limit) {
        var searchParams, response;
        if (limit === void 0) { limit = 20; }
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    searchParams = new URLSearchParams();
                    searchParams.append("search", search);
                    if (type)
                        searchParams.append("type", type);
                    searchParams.append("limit", limit.toString());
                    return [4 /*yield*/, kyInstance.get(legalDepositsTitlesIdMergeCandidates(provisionalId), { searchParams: searchParams, headers: getHeaders() })];
                case 1:
                    response = _a.sent();
                    if (!response.ok) {
                        throw new Error("Fetch merge candidates error: ".concat(response.statusText));
                    }
                    return [2 /*return*/, response.json()];
            }
        });
    });
};
export var forceDeleteProvisionalTitle = function (kyInstance, id) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, kyInstance.delete(legalDepositsTitlesIdForce(id), {
                    headers: getHeaders(),
                })];
            case 1:
                response = _a.sent();
                if (!response.ok) {
                    throw new Error("Force delete provisional title error: ".concat(response.statusText));
                }
                return [2 /*return*/];
        }
    });
}); };
export var deleteProvisionalTitle = function (kyInstance, id) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, kyInstance.delete(legalDepositsTitlesId(id), {
                    headers: getHeaders(),
                })];
            case 1:
                response = _a.sent();
                if (!response.ok) {
                    throw new Error("Delete provisional title error: ".concat(response.statusText));
                }
                return [2 /*return*/];
        }
    });
}); };
export var startInvestigationByTitles = function (kyInstance, selection, note) { return __awaiter(void 0, void 0, void 0, function () {
    var response, error_14;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                return [4 /*yield*/, kyInstance.patch(API_PATHS.LEGAL_DEPOSITS_TITLES_START_INVESTIGATION_BY_TITLES, { json: { selection: selection, note: note }, headers: getHeaders() })];
            case 1:
                response = _a.sent();
                if (!response.ok) {
                    throw new Error("Bulk start investigation error: ".concat(response.statusText));
                }
                return [4 /*yield*/, response.json()];
            case 2: return [2 /*return*/, _a.sent()];
            case 3:
                error_14 = _a.sent();
                console.error("Error bulk-starting investigation:", error_14);
                throw error_14;
            case 4: return [2 /*return*/];
        }
    });
}); };
